'use strict';

define(['app', 'elementViewed'], function (app, elementViewed) {

  var primaryBanner = function primaryBanner() {
    var component = {};
    component.elementViewed = elementViewed;

    var _init = function _init(element) {
      component.element = element;
      component.bind();
      return component;
    };

    var _bind = function _bind() {
      component.elementViewed(component.element, component.primaryBannerViewed);
    };

    var _primaryBannerClicked = function _primaryBannerClicked() {
      app.publish('tracking/record', 'Widget Track', 'Clicked', component.element.getAttribute("data-block-name"), component.element.getAttribute("data-widget-id"));
    };

    var _primaryBannerViewed = function _primaryBannerViewed() {
      app.publish('tracking/record', 'Widget Track', 'Viewed', component.element.getAttribute("data-block-name"), component.element.getAttribute("data-widget-id"));
    };

    component.init = _init;
    component.bind = _bind;
    component.primaryBannerClicked = _primaryBannerClicked;
    component.primaryBannerViewed = _primaryBannerViewed;
    return component;
  };

  return primaryBanner;
});
//# sourceMappingURL=primaryBanner.js.map
